export default __webpack_public_path__ + "static/media/situation-coref-entity-changes.dd190db8.gif";